/* eslint no-console: off */
import React from 'react';
import ReactGridLayout, { WidthProvider, Responsive } from 'react-grid-layout';
import _ from 'lodash';
const ResponsiveReactGridLayout = WidthProvider(Responsive);
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import { Widget } from './widget-edit';
import { TimeRange } from './timeRange';
import { toGridItem, WidgetDefinition,  Widget as WidgetType, } from './utils/utils';
import Charts from 'app/components/charts';

export const MIN_WIDGET_WIDTH = 3;
export const MIN_WIDGET_HEIGHT = 3;
export const MIN_WIDGET_HEIGHT_MAP = 4;
export const MIN_WIDGET_WIDTH_MAP = 12;

export type GridLayoutProps = {
  widgets: Array<WidgetType>;
  timeRange: any;
  theme?: string;
  onDeleteWidget: (widget: WidgetType) => void;
  onLayoutChange: (layout: Array<WidgetType>) => void;
  onUpdateWidget: (widget: WidgetDefinition) => void;
  onBreakpointChange: (b: string, cols: number) => void;
  setEditWidgetItem: (widget: WidgetType | null) => void;
  setIsAddWidgetModalOpen: (open: boolean) => void;
  mode: string
};

export const WidgetGridLayout= React.forwardRef<HTMLDivElement, GridLayoutProps>((props, ref) => {
  const { setIsAddWidgetModalOpen, setEditWidgetItem, mode} = props;

  const showUpdateWidget = (el: WidgetType) => {
    setIsAddWidgetModalOpen(true);
    setEditWidgetItem(el);
  };

  const handleDeleteWidget = (el: WidgetType) => {
    props.onDeleteWidget(el);
  };

  const onLayoutChange = (layout: Array<ReactGridLayout.Layout>) => {
    const widgets = props?.widgets?.map(itm => {
      const layoutItem = layout.find(element => element.i === itm.id.toString());
      return {
        ...itm,
        layout: {
          ...itm.layout,
          x: layoutItem.x,
          y: layoutItem.y,
          minW: layoutItem.minW,
          minH: layoutItem.minH,
          width: layoutItem.w,
          height: layoutItem.h,
        },
      };
    });
    props.onLayoutChange(widgets);
  };

  return (
    <>
      <div ref={ref}>
        <ResponsiveReactGridLayout
          className={'layout'}
          resizeHandles={['sw', 'nw', 'se', 'ne']}
          draggableHandle=".drag"
          margin={[20, 20]}
          onLayoutChange={layout => {
            onLayoutChange(layout);
          }}
          onBreakpointChange={props.onBreakpointChange}
          breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
          cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
          rowHeight={100}
          verticalCompact={true}
          compactType="vertical"
          layouts={{
            lg: props?.widgets?.map(widget => {
              return {
                ...toGridItem(widget),
                minH: MIN_WIDGET_HEIGHT,
                minW: MIN_WIDGET_WIDTH,
                isDraggable: true,
                isResizable: true,
              };
            }),
          }}
        >
          {props?.widgets?.map((el, i) => {
            return (
              <div key={el.id} data-grid={toGridItem(el)}>
                <Widget
                  theme={props.theme}
                  widget={el}
                  itemIndex={i}
                  onRemove={() => handleDeleteWidget(el)}
                  onEdit={() => showUpdateWidget(el)}
                >
                   <Charts
                    theme={props.theme}
                    colorScheme={el.definition?.colorScheme?.value}
                    widgetOption={el.definition?.widgetOption}
                    dataQuery={el.definition?.dataQuery}
                    timeRange={props.timeRange}
                    type={el.definition?.type}
                    updateOnce={mode !== "view"}
                    width={500}
                    height={350}
                    margin={20}
                    preview={false}
                  />
                </Widget>
              </div>
            );
          })}
        </ResponsiveReactGridLayout>
      </div>
    </>
  );
});
